import { createSlice } from '@reduxjs/toolkit'; 

const globalSlice = createSlice({
  name: 'global',
  initialState: {
    userProfile: undefined,
  },
  reducers: {
    setUserProfile: (state, action) => {
      state.userProfile = action.payload;
    },
  },
});

export const { setUserProfile } = globalSlice.actions;
export default globalSlice.reducer;